import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brand-gravatar', 'IconBrandGravatar', [["path",{"d":"M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714","key":"svg-0"}]]);